"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var variable_value_styles_1 = require("./variable-value.styles");

var Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));

var VariableValue = function VariableValue(_ref) {
  var variable = _ref.variable,
      onClick = _ref.onClick;
  return react_1.default.createElement(Tooltip_1.default, {
    placement: "top",
    title: variable.label,
    "aria-label": variable.label
  }, react_1.default.createElement(variable_value_styles_1.HighlightSpan, {
    onClick: onClick,
    clickable: !!onClick
  }, variable.value));
};

exports.default = VariableValue;